const styles = `<style id="signature-digital">
#signature-digital {
  user-select: none;
}
#signature-digital__title {
  font-size: 14px;
  color: #18191A;
  font-weight: bold;
  display: inline-block;
  position: relative;
  cursor: pointer;
}
#signature-digital__input {
  border: none;
  border-bottom: 2px solid #18191A;
  width: 184px;
  color: #18191A;
  font-size: 26px;
  letter-spacing: 6px;
  padding: 4px 12px 5px 30px;
  box-sizing: border-box;
  outline: none;
  margin-bottom: 12px;
  user-select: none;
  display: block;
}
#signature-digital__input:disabled {
  pointer-events: none;
  background: transparent;
}
#signature-digital__input:disabled {
  opacity: 1;
}
.signature-digital__error {
  display: none;
  margin-bottom: 10px;
  color: #E64230;
}
.signature-digital__error--show {
  display: block;
}
#signature-digital__ico-lock {
  position: absolute;
  top: 33px;
  left: 1px;
  z-index: 2;
}
#signature-digital__group {
  max-width: 280px;
  margin-bottom: 20px;
}
#signature-digital__group button {
  width: 70px;
  height: 34px;
  color: #18191A;
  user-select: none;
  font-size: 16px;
  margin: 20px 20px 0 0;
  border: 1px solid #DBDBDB;
  border-radius: 1px;
  outline: none;
  background-color: #F4F4F4;
}
#signature-digital__group button:nth-child(3),
#signature-digital__group button:nth-child(6) {
  margin-right: 0;
}
@media screen and (max-width: 768px) {
  #signature-digital__group button {
    height: 50px;
  }
}
#signature-digital__group button:hover {
  border-color: #FFC300;
  background-color: #FFC300;
  cursor: pointer;
}
#signature-digital__forgot-password {
  border: none;
  outline: none;
  padding: 6px 0;
  cursor: pointer;
  font-size: 16px;
  background: transparent;
  border-bottom: 1px solid #FFC300;
  position: relative;
}
#signature-digital__forgot-password:hover {
  border-bottom-width: 2px;
  padding-bottom: 5px;
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -600px 0;
  }

  100% {
    background-position: 600px 0;
  }
}
#signature-digital__group .skltn {
  position: relative;
  animation-duration: 1.3s;
  animation-iteration-count: infinite;
  will-change: background-position;
  border-color: #eee;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #eee;
  background: linear-gradient(90deg, #eee 8%, #ddd 18%, #eee 33%);
  background-size: 1200px 104px;
}

#signature-digital__group .skltn:hover {
  border-color: #eee;
}
#signature-digital__forgot-password-message--success,
#signature-digital__forgot-password-message--error {
  border: 1px solid #DDDDDD;
  padding: 15px;
  display: inline-block;
  margin-top: 20px;
  font-size: 16px;
}
#signature-digital__forgot-password-message--success {
  border-left: 2px solid #FFC709;
}
#signature-digital__forgot-password-message--error {
  border-left: 2px solid #E64230;
}
#signature-digital__loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #FFC300;
  width: 18px;
  height: 18px;
  -webkit-animation: spin 600ms linear infinite; /* Safari */
  animation: spin 600ms linear infinite;
  position: absolute;
  top: 4px;
  right: -34px;
  display: none;
}
.signature-digital__loader--show {
  display: inline-block !important;
}
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>`;
export default styles;